// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__t7eC9","containerItemsCenter":"Skeleton_containerItemsCenter__1qWAE"};